export default function CTASection() {
  return (
    <section className="relative py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20fashion%20accessories%20and%20lifestyle%20items%20arranged%20on%20a%20warm%20terracotta%20linen%20surface%2C%20a%20pair%20of%20pristine%20white%20leather%20sneakers%20with%20delicate%20sage%20green%20embroidery%2C%20a%20soft%20cream%20colored%20cashmere%20scarf%20draped%20beside%20them%2C%20minimalist%20gold%20jewelry%20pieces%2C%20a%20ceramic%20vase%20with%20dried%20pampas%20grass%20in%20the%20background%2C%20warm%20golden%20hour%20sunlight%20streaming%20from%20the%20side%2C%20soft%20dreamy%20bokeh%20effect%2C%20high-end%20editorial%20composition%2C%20rich%20warm%20neutral%20palette%2C%20luxurious%20yet%20approachable%20aesthetic&width=1600&height=700&seq=cta-v2-01&orientation=landscape"
            alt="OOPBUY Spreadsheet CTA"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50"></div>

          <div className="relative z-10 px-6 md:px-16 py-16 md:py-20 flex flex-col items-center text-center">
            <h2 className="font-heading text-3xl md:text-5xl text-background-50 font-bold leading-tight max-w-2xl">
              Bereit für das <span className="italic">OOPBUY Spreadsheet</span>?
            </h2>
            <p className="mt-5 text-background-50/80 text-base md:text-lg max-w-xl leading-relaxed">
              Entdecken Sie alle Kategorien und finden Sie die besten Produkte. 
              Jetzt auf kaspreadsheet.com durchstarten.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 px-8 py-4 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap hover:scale-105"
            >
              Buy it now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}